






/**
 * @copyright       Palace Resorts
 * @description     Pantalla snackbar
 */
import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {},
  props: {
    snackbar: { type: Boolean, default: false },
    text: { type: String, default: "" },
    timeout: { type: Number, default: 2000 },
    color: { type: String, default: "" },
  },
  data: () => {
    return {
      // GENERAL
      moduleName: "SNACKBAR",
    };
  },
  methods: {
    closeSnackbar() {
      this.$emit("closeSnackbar");
    },
  },
});
